export var newStyles = {
    colorStyles: [
        { id: 'color:1', name: 'Primary', value: '#0FC08D' },
        { id: 'color:2', name: 'Primary Shade', value: '#0B906A' },
        { id: 'color:3', name: 'Secondary', value: '#0F96C0' },
        { id: 'color:4', name: 'Secondary Shade', value: '#0B7190' },
        { id: 'color:5', name: 'Background', value: '#F8F8FB' },
        { id: 'color:6', name: 'Text', value: '#252525' },
        { id: 'color:7', name: 'Subtext', value: '#696969' },
        { id: 'color:8', name: 'Info', value: '#7496EB' },
        { id: 'color:9', name: 'Warning', value: '#FF9966' },
        { id: 'color:10', name: 'Error', value: '#FF6666' },
    ],
    textStyles: [
        {
            id: 'text:1',
            name: 'Title 1',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 24,
                fontWeight: '700',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:2',
            name: 'Title 2',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 24,
                fontWeight: '600',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:3',
            name: 'Title 3',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 22,
                fontWeight: '600',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:4',
            name: 'Title 4',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 22,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:5',
            name: 'Subtitle 2',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 18,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:6',
            name: 'Subtitle 2',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 18,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:7',
            name: 'Body Text 1',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 18,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:8',
            name: 'Body Text 2',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 16,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:9',
            name: 'Button Text',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 16,
                fontWeight: '600',
                letterSpacing: 0,
            },
        },
        {
            id: 'text:10',
            name: 'Subtext',
            values: {
                fontFamily: 'Open Sans',
                fontSize: 12,
                fontWeight: '400',
                letterSpacing: 0,
            },
        },
    ],
};
